import React, { useState, useEffect } from 'react';
import BackIcon from '../../images/white_left_arrow.png';
import { useNavigate } from 'react-router';
import styles from './styles.module.scss';
import { Image } from 'react-bootstrap';

export default function BackButton({ route }) {

    const navigate = useNavigate();
    const [canGoBack, setCanGoBack] = useState(false);

    useEffect(() => {
      if (route) {
        setCanGoBack(true);
      } else if (window.history.length >= 2) {
        setCanGoBack(true);
      }
    }, [route]);
  
    const goBack = () => {
      if (route) {
        navigate(route);
      } else {
        navigate(-1);
      }
    };
  
    if (!canGoBack) {
      return null;
    }

    return(
        <div className={`d-flex align-items-center justify-content-center col-12 ${styles.container}`} onClick={goBack}>
            <div 
              className="col-3 ms-5 col-md-1 d-flex justify-content-center align-items-center 
                        rounded-circle bg-danger" 
              style={{ width: "24px", height: "24px" }}
            >
              <Image src={BackIcon} fluid style={{ width: "12px", height: "12px" }} />
            </div>
            <div className="d-flex align-items-center pt-1 my-0 ms-2 ms-md-3">
              Tilbake
            </div>
        </div>
    )
}